import {
  httpDelete,
  httpGet, httpPost, httpPut,
} from '../httpCalls';
import {
  resetForm,
  createForm,
  updateLocalForm,
  reloadForm,
  updateForm,
} from '../../actions/formActions';
import { reloadError } from '../../actions/errorActions';
import { createSession } from '../../actions/sessionActions';
import { createAdditionalMetadata, resetAdditionalMetadata } from '../../actions/additionalMetadataActions';

/* eslint-disable import/prefer-default-export */

export const mapDispatchToProps = (dispatch) => ({
  getItem: (url, ref = null) => {
    // dispatch(resetForm());
    return httpGet(url).then((valuesRequest) => {
      dispatch(createForm(valuesRequest));
      if (ref && 'current' in ref) {
        ref.current = valuesRequest;
      }
    });
  },
  getAdditionalMetadata: (url) => {
    dispatch(resetAdditionalMetadata());
    return httpGet(url).then((valuesRequest) => {
      dispatch(createAdditionalMetadata(valuesRequest));
    });
  },
  getNewDefaults: (url) => {
    return httpGet(url).then((result) => {
      dispatch(updateForm(result));
    });
  },
  createItem: (url, item) => httpPost(url, item).then((newItem) => {
    dispatch(createForm(newItem));
    return newItem;
  }, (error) => {
    dispatch(reloadError(error));
    return Promise.reject(error);
  }),
  updateItem: (url, item,updateRedux) => httpPut(url, item).then((result) =>{
    if(updateRedux){
      dispatch(updateForm(result));
    }
    return result;
    },(error) => {
      dispatch(reloadError(error));
      return Promise.reject(error);
  }),
  updateItemWithRefresh: (url, item) => httpPut(url, item).then((result) => {
    dispatch(createForm(result));
  }, (error) => {
    dispatch(reloadError(error));
    return Promise.reject(error);
  }),
  deleteItem: (url, item) => httpDelete(url, item).then((result) => {
    dispatch(createForm(result));
  }, (error) => {
    dispatch(reloadError(error));
    return Promise.reject(error);
  }),
  updateLocalItem: (item, attribute) => {
    dispatch(updateLocalForm(item, attribute));
  },
  updateAllItems: (items)=>{
    dispatch(reloadForm(items));
  },
  resetForm: () => dispatch(resetForm()),
  resetAdditionalMetadata: () => dispatch(resetAdditionalMetadata()),
  formEdited: (value = true) => {
    dispatch(createSession({ isBlocking: value }))},
});
